import { render } from "./protocol.vue?vue&type=template&id=d3f9a37c"
import script from "./protocol.vue?vue&type=script&lang=js"
export * from "./protocol.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/protocol/create/protocol.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d3f9a37c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d3f9a37c', __exports__)) {
    console.log('reload')
    api.reload('d3f9a37c', __exports__)
  }
  
  module.hot.accept("./protocol.vue?vue&type=template&id=d3f9a37c", () => {
    console.log('re-render')
    api.rerender('d3f9a37c', render)
  })

}


export default __exports__